import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ReviewDetail } from '../../../core/model/v2/review/review-detail';
import { PhysicianReviewDetailsComponent } from '../physician-review-details/physician-review-details.component';

@Component({
  selector: 'app-physician-review',
  templateUrl: './physician-review.component.html',
  styleUrls: ['./physician-review.component.scss']
})
export class PhysicianReviewComponent implements OnInit {

  details: ReviewDetail;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<PhysicianReviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReviewDetail
  ) { }

  ngOnInit() {
    this.details = this.data;
  }

  viewAllDetails(): void {
    this.dialogRef.close();
    const dialogDetail = this.dialog.open(PhysicianReviewDetailsComponent, {
      width: '40vw',
      data: this.data
    });
  }

}
